import { BasePublicApi } from '#packages/apilib';
import type { Scope } from './scope';
import { fixedStage } from '#packages/util';
import { domMeasurements } from '#packages/stateManagement';

const { getEditorContentLayout } = domMeasurements.selectors;

export function isStageFixedInDesktop(scope: Scope) {
  return fixedStage.isFixedStageEnabled() && !scope.editorAPI.isMobileEditor();
}

export function isTopBarMinimized(scope: Scope) {
  const { editorConfig, language, store } = scope.editorAPI;
  return (
    fixedStage.isFixedStageEnabled() &&
    language?.multilingual.isEnabled() &&
    getEditorContentLayout(store.getState()).width < editorConfig.minTopBarWidth
  );
}

export class FixedStageApi extends BasePublicApi<Scope> {
  isStageFixedInDesktop = this.bindScope(isStageFixedInDesktop);
  isTopBarMinimized = this.bindScope(isTopBarMinimized);
}
